var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecharge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.21346 8.85331H8.27346V13.6533C8.27346 14.36 9.15346 14.6933 9.62012 14.16L14.6668 8.42665C15.1068 7.92665 14.7535 7.14665 14.0868 7.14665H12.0268V2.34665C12.0268 1.63998 11.1468 1.30665 10.6801 1.83998L5.63346 7.57331C5.20012 8.07331 5.55346 8.85331 6.21346 8.85331Z",
    fill: "#4343D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66667 3.16699H1C0.726667 3.16699 0.5 2.94033 0.5 2.66699C0.5 2.39366 0.726667 2.16699 1 2.16699H5.66667C5.94 2.16699 6.16667 2.39366 6.16667 2.66699C6.16667 2.94033 5.94 3.16699 5.66667 3.16699Z",
    fill: "#4343D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 13.833H1C0.726667 13.833 0.5 13.6063 0.5 13.333C0.5 13.0597 0.726667 12.833 1 12.833H5C5.27333 12.833 5.5 13.0597 5.5 13.333C5.5 13.6063 5.27333 13.833 5 13.833Z",
    fill: "#4343D6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.5H1C0.726667 8.5 0.5 8.27333 0.5 8C0.5 7.72667 0.726667 7.5 1 7.5H3C3.27333 7.5 3.5 7.72667 3.5 8C3.5 8.27333 3.27333 8.5 3 8.5Z",
    fill: "#4343D6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecharge);
export default __webpack_public_path__ + "static/media/recharge.b98bba41a71d9883612d3c80a816ab8e.svg";
export { ForwardRef as ReactComponent };